import React from 'react';
import { motion } from 'framer-motion';
type SectionProps = {
  id?: string;
  children: React.ReactNode;
  className?: string;
  innerClassName?: string;
  label?: string;
};
export function Section({
  id,
  children,
  className = '',
  innerClassName = '',
  label
}: SectionProps) {
  return <section id={id} aria-label={label} className={`w-full px-5 py-16 sm:px-8 sm:py-24 ${className}`} data-id="element-252" data-mp="3kv88g7iptoom">
      <motion.div initial={{
      opacity: 0,
      y: 24
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.15
    }} transition={{
      duration: 0.3,
      ease: [0.22, 1, 0.36, 1]
    }} className={`mx-auto w-full max-w-4xl ${innerClassName}`} data-id="element-253" data-mp="cfwut85jxpog">
        {children}
      </motion.div>
    </section>;
}
export function SectionTitle({
  eyebrow,
  children
}: {
  eyebrow?: string;
  children: React.ReactNode;
}) {
  return <div className="mb-10" data-id="element-254" data-mp="vd7taqjd0f2u">
      {eyebrow ? <p className="mb-3 text-xs font-semibold uppercase tracking-[0.22em] text-accent-soft" data-id="element-255" data-mp="105iwc29ecgzm">{eyebrow}</p> : null}
      <h2 className="text-3xl font-extrabold leading-[1.15] tracking-tight text-white sm:text-4xl" data-id="element-256" data-mp="2zldazvhoiq97">{children}</h2>
    </div>;
}